import { Button, Divider, Drawer, Fab, Grid, makeStyles, Typography } from '@material-ui/core';
import FilterListIcon from '@material-ui/icons/FilterList';
import { defer } from '@thalesrc/js-utils';
import React, { useCallback, useContext, useRef } from 'react';

import AutoComplete from 'Common/Form/AutoComplete';
import DateInput from 'Common/Form/DateInput';
import Form, { FormRef } from 'Common/Form/Form';
import TextField from 'Common/Form/TextField';
import { HSTableContext } from 'Common/Table/HSTable/hs-table.context';
import Toolbar from 'Common/Toolbar';
import { SelectOptionsContext } from 'context/select-options.context';
import { useAsyncEffect, useDialogState } from 'utils';

const useStyles = makeStyles(() => ({
  fab: {
    transform: 'translateY(50%)',
  },
  drawer: {
    maxWidth: 320,
  },
}));

export default function Filters() {
  const classes = useStyles();
  const { open, close, opened } = useDialogState();
  const { setExtraArgs, extraArgs } = useContext(HSTableContext);
  const { ppeDefinitions, ppeTypeDefinitions, storeHouse, ppeClassificationDefinitions } = useContext(SelectOptionsContext);
  const formRef = useRef<FormRef<Record<string, any>>>();

  const submit = useCallback(
    values => {
      setExtraArgs({ filters: values });
      close();
    },
    [setExtraArgs, close]
  );

  const clear = useCallback(() => {
    setExtraArgs({ filters: {} });
    close();
  }, [setExtraArgs, close]);

  useAsyncEffect(async () => {
    if (!extraArgs.filters || !opened) {
      return;
    }

    await defer();

    for (const [key, value] of Object.entries(extraArgs.filters)) {
      formRef.current.methods.setValue(key, value);
    }

    formRef.current.methods.trigger();
  }, [extraArgs, opened]);

  return (
    <>
      <Fab
        onClick={open}
        size="small"
        className={classes.fab}
        style={{
          backgroundColor: `${
            Object.keys(extraArgs)?.length > 0 ? (Object.keys(extraArgs?.filters)?.length > 0 ? '#f50057' : '#2196f3') : '#2196f3'
          }`,
          color: 'white',
        }}>
        <FilterListIcon />
      </Fab>
      <Drawer anchor="left" open={opened} onClose={close} classes={{ paper: classes.drawer }}>
        <Toolbar color="secondary" className="mb-2">
          <Typography variant="h6">KKD Girdi Filtreleme</Typography>
        </Toolbar>
        <Form onSubmit={submit} ref={formRef}>
          <Grid container className="p-2">
            <Grid item xs={12}>
              <AutoComplete name="ppeDefinitionIds" options={ppeDefinitions} label="KKD Tanımları" />
            </Grid>
            <Grid item xs={12}>
              <AutoComplete name="ppeTypeDefinitionIds" options={ppeTypeDefinitions} label="KKD Tipi" />
            </Grid>
            <Grid item xs={12}>
              <AutoComplete name="classificationDefinitionIds" options={ppeClassificationDefinitions} label="KKD Sınıflandırma" />
            </Grid>
            <Grid item xs={12}>
              <AutoComplete name="storehouseDefinitionIds" options={storeHouse} label="Depolar" />
            </Grid>
            <Grid item xs={12}>
              <TextField type="number" name="stockNumber" label="Stok Numarası" />
            </Grid>
            <Grid container spacing={1} item xs={12}>
              <Grid item xs={12}>
                <Typography variant="subtitle1">Üretim Tarihi</Typography>
                <Divider />
              </Grid>
              <Grid item xs={6}>
                <DateInput type="date" name="productionDateMin" label="Başlangıç" />
              </Grid>
              <Grid item xs={6}>
                <DateInput type="date" name="productionDateMax" label="Bitiş" />
              </Grid>
            </Grid>
            <Grid className="mt-1" container spacing={1} item xs={12}>
              <Grid item xs={12}>
                <Typography variant="subtitle1">Son Kullanma Tarihi</Typography>
                <Divider />
              </Grid>
              <Grid item xs={6}>
                <DateInput type="date" name="expireDateMin" label="Başlangıç" />
              </Grid>
              <Grid item xs={6}>
                <DateInput type="date" name="expireDateMax" label="Bitiş" />
              </Grid>
            </Grid>
          </Grid>
          <footer className="px-2 flex-justify">
            <Button className="mr-1" fullWidth type="button" variant="contained" onClick={clear}>
              Temizle
            </Button>
            <Button fullWidth type="submit" variant="contained" color="secondary">
              Filtrele
            </Button>
          </footer>
        </Form>
      </Drawer>
    </>
  );
}
